

import { onMounted, reactive, computed, ref, onUnmounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import QRCode from 'qrcodejs2'
import { copyToClipboardUsingTextarea, isAndroid, isIOS } from '@/utils/utils'
import Tips from '@/components/share/Tips.vue'
import MaskLayer from '@/components/share/MaskLayer.vue'
import DialogShareTips from '@/components/share/DialogShareTips.vue'
import Fade from '@/components/transitions/Fade.vue'
import DialogReferralRewards from '@/components/share/DialogReferralRewards.vue'
import { websiteHost_ } from '@/config/config'
import ScreenShot from '@/components/share/ScreenShot.vue'
import { callApi, callPostApi, sendMessageToFlutter } from '@/api/api'
import Spinner from '@/components/transitions/Spinner.vue';
import DialogShareCode from '@/components/share/DialogShareCode.vue'
import SlideDown from '@/components/transitions/SlideDown.vue'
// import FadeDown from '@/components/transitions/FadeDown.vue'
import DialogRewardsRecords from '@/components/share/DialogRewardsRecords.vue'
import DialogApplyGift from '@/components/share/DialogApplyGift.vue'
import DialogSuccessGift from '@/components/share/DialogSuccessGift.vue'
import DialogRewardRules from '@/components/share/DialogRewardRules.vue'
import DialogSaveImage from '@/components/share/DialogSaveImage.vue'
import ErrorTips from '@/components/transitions/ErrorTips.vue';
import DialogSaveImageError from '@/components/share/DialogSaveImageError.vue'
import { nextTick } from 'process'
// import { apiHost } from '@/config/config'


export default {
    name: 'Share',
    components: {
        Tips,
        MaskLayer,
        DialogShareTips,
        Fade,
        DialogReferralRewards,
        ScreenShot,
        Spinner,
        DialogShareCode,
        SlideDown,
        // FadeDown,
        DialogRewardsRecords,
        DialogApplyGift,
        DialogSuccessGift,
        DialogRewardRules,
        DialogSaveImage,
        ErrorTips,
        DialogSaveImageError
    },

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    setup() {
        onMounted(async () => {
            await store.dispatch(`translation/getLangs`, { userLang: route.query.lang })
            openComponent('showLoading')
            if (data.encryptedToken) {
                let resData = await callApi(`/user/points`, 'GET', data.encryptedToken as any)
                if (resData.isSuccess) {
                    await store.dispatch('share/setShareInfo', resData)
                } else {
                    await store.dispatch('share/setShareInfo', data.defaultShareInfo)

                    router.push(errorRoute.value)
                }

                let gifts = await callApi(`/user/points/gifts`, 'GET', data.encryptedToken as any, langQuery.value)
                .finally(()=>closeComponent('showLoading'))
                if (gifts.isSuccess && gifts.status) {
                    let toClaim = [] as any
                    let toInvites = [{
                        description: local.value.des_extra_points_1+shareInfo.value.MaxReferralsOfAvailableGifts+local.value.des_extra_points_2+shareInfo.value.extraGiftedPoints+local.value.des_extra_points_3,
                        disabled: true,
                        id: 'pm350',
                        not_given_before: true,
                        packageName: shareInfo.value.extraGiftedPoints+local.value.apply_p,
                        package_id: null,
                        points: shareInfo.value.extraGiftedPoints,
                        referrals: Number.MAX_SAFE_INTEGER,
                        sorting_order:Infinity,
                        state: "s2",
                        title: shareInfo.value.extraGiftedPoints+local.value.apply_p,
                        userCurrentReferrals: 1,
                        _id: null
                    }] as any
                    let received = [] as any
                    gifts.data.forEach(item => {
                       if(!item.disabled && item.not_given_before) {
                           toClaim.push({...item,state:'s1'})
                       } else if(item.disabled && item.not_given_before && item.userCurrentReferrals < item.referrals) {
                           toInvites.push({...item,state:'s2'})
                       } else if(item.disabled && !item.not_given_before) {
                           received.push({...item,state:'s3'})
                       }
                    })
       
                    toClaim.sort((a,b)=>a.sorting_order - b.sorting_order)
                    toInvites.sort((a,b)=>a.sorting_order - b.sorting_order)
                    received.sort((a,b)=>a.sorting_order - b.sorting_order)
                    await store.dispatch('share/setGiftsList', [...toClaim,...toInvites,...received])
                } else {
                    await store.dispatch('share/setGiftsList', null)

                    router.push(errorRoute.value)
                }
            } else {
                router.push(errorRoute.value)
            }
        })

        // Start label width monitoring
        let observer :any = null
        onMounted(() => {
            nextTick(() => {
                updateLabelWidth()
                if('ResizeObserver' in window) {
                    observer = new (window as any).ResizeObserver(() => {
                        updateLabelWidth()
                    })

                    if (leftLabelRef.value) {
                        observer.observe(leftLabelRef.value)
                    }
                }else {
                    // fallback for old WebView
                    (window as any).addEventListener('resize', () => updateLabelWidth)
                }
            })

        })

        // End label width monitoring
        onUnmounted(() => {
            observer?.disconnect()
            window.removeEventListener('resize', updateLabelWidth)
        })


        type TipsInstance = {
            showTips: (data: { show: boolean; title: string }) => void;
        };

        type ScreenShot = {
            captureScreenshot: (code: string) => void;
        }

        const textToCopy = ref<HTMLElement | null>(null);
        const tipsRef = ref<TipsInstance | null>(null);
        const screenShotRef = ref<ScreenShot | null>(null);
        const errorRef = ref<TipsInstance | null>(null);
        const currentTab = ref('tab1')
        const leftLabelRef = ref<HTMLElement | null>(null)
        const labelWidth = ref(0)

        const store = useStore()
        const route = useRoute()
        const router = useRouter()

        const saveImage = computed(() => store.state.share.saveImage)
        const local = computed(() => store.state.translation.locale)
        const shareInfo = computed(() => store.state.share.shareInfo)
        const nextStep = computed(() => {
            const invites = shareInfo.value.sharesThisMonth.total_active_invites

            // calc arr refs
            let arr1 = giftsList.value
            let arr = [] as any;
            if(arr1 === null) {
                return []
            } else {
                for(let i=0 ; i<arr1.length ; i++) {
                if(arr1[i] && arr1[i].referrals) {
                     arr.push(arr1[i].referrals as any)
                }
            }
            arr.sort((a,b)=>(a-b))
            }

            // calc arr refs

            // new updates nextStep
            for(let i =0 ; i<arr.length-1;i++ ) {
                if(invites < arr[i]) {
                    return arr[i];
                } else if(i === arr.length-2 && invites === arr[i]) {
                    return arr[i]+1;
                }
            }
            return invites+1;
        })
        const currentLabel = computed(() => {
            if(giftsList.value === null) return '---'
            for(let i=0;i<giftsList.value.length;i++) {
                if(giftsList.value[i]){
                    if(giftsList.value[i].referrals === nextStep.value) {
                        return giftsList.value[i].packageName
                    }
                }
            }
            return shareInfo.value.extraGiftedPoints+local.value.apply_p
        }) 
        const getCurrentWidth = computed(() => {
            const invites = Number(shareInfo.value.sharesThisMonth.total_active_invites)
            if(!referralsArray.value.length) return 0
            if(invites === 0) {
                return 0
            }
            
            // new updates
            let refs = [0,...referralsArray.value]
            let steps = [0,15,30,50,70,85,Number.MAX_SAFE_INTEGER] as any
             steps = [0,filteredGifts.value[0]?15:null,filteredGifts.value[1]?30:null,filteredGifts.value[2]?50:null,filteredGifts.value[3]?70:null,filteredGifts.value[4]?85:null,Number.MAX_SAFE_INTEGER].filter(item => item!==null)
            for(let i=1;i<refs.length-1;i++) {
                if(invites>refs[i-1] && invites<refs[i]) {
                    let v = steps[i-1]+((invites-refs[i-1])/(refs[i]-refs[i-1]))*(steps[i]-steps[i-1])  // Linear Interpolation
                    let v1 = steps[i-1]
                    let v2 = steps[i]
                    if((Math.abs(v-v1)<=4 && v<v1)) return v-(5-(Math.abs(v-v1)))  // => 30px width of circule gift / 2 = 15px , line width 320 / 100 = 3.2 => 15px/3.2 = 4 or 5 steps is 15px
                    else if((Math.abs(v-v2)<=4 && v<v2)) return v-(5-(Math.abs(v-v2)))
                    else if((Math.abs(v-v1)<=4 && v>v1)) return v+(5-(Math.abs(v-v1)))
                    else if((Math.abs(v-v2)<=4 && v>v2)) return v+(5-(Math.abs(v-v2)))
                    else return v
                }
            
                else if(invites===refs[i]) {
                    return steps[i]
                }
            }
             return 100
        })

        const currentDataTab = computed(()=> {
            if(currentTab.value === 'tab1') {
                return shareInfo.value.sharesThisMonth
            } else {
                return shareInfo.value.sharesLastSixMonths
            }
        })

        const currentPointsMode = computed(()=> {
            if(currentTab.value === 'tab1') {
                return {
                    sharePointsIn:shareInfo.value.currentMonthSharePointsIn,
                    purchasePointsIn:shareInfo.value.currentMonthPurchasePointsIn
                }
            } else {
                return {
                    sharePointsIn:shareInfo.value.sixMonthsSharePointsIn,
                    purchasePointsIn:shareInfo.value.sixMonthsPurchasePointsIn
                }
            }
        })

        const currentPointsBalance = computed(()=> {
            return (shareInfo.value.sharesThisMonth.total_active_invites - shareInfo.value.MaxReferralsOfAvailableGifts)*shareInfo.value.extraGiftedPoints
        })
        const link = computed(() => `${websiteHost_}/share_link?code=${store.state.share.shareInfo.inviteCode}`)
        const host = computed(() => window.location.host)
        
        const currentMonth = computed(() => {
            return {
                name: data.monthNames[new Date().getMonth()].en,
                number: data.monthNames[new Date().getMonth()].zh
            }
        })
        const lastDayFromMonth = computed(() => {
            let now = new Date()
            let month = now.getMonth()
            let year = now.getFullYear()
            return new Date(year,month+1,0).getDate()
        })

        const giftsList = computed(() => {
            return  store.state.share.giftsList
        })

        const filteredGifts = computed(() => {
            let rawGifts = giftsList.value
            if(rawGifts === null) return [null,null,null,null,null,null] 
            const gifts = [...rawGifts]
            gifts.sort((a,b)=>(a.referrals - b.referrals))
            const len = gifts.length

            if(len === 0) return []
            else if(len === 1) {
                return [null,null,null,null,null,gifts[0]] 
            } else if(len === 2) {
                return [gifts[0],null,null,null,null,gifts[1]]
            } else if(len === 3) {
                return [gifts[0],null,null,null,gifts[1],gifts[2]]
            } else if(len === 4) {
                return [gifts[0],null,gifts[1],null,gifts[2],gifts[3]]
            } else if(len === 5) {
                return [gifts[0],gifts[1],gifts[2],null,gifts[3],gifts[4]]
            } else if (len === 6) {
                return gifts
            } else {
                let finalItem = gifts[len-1]
                let critical = gifts[len-2]
                let nextItem = null as any
                let nextIndex = -1
                gifts.forEach((item,index) => {
                    if(nextStep.value === item.referrals && nextStep.value !== critical.referrals) {
                        nextItem = item
                        nextIndex = index
                    }
                })
                if(!nextItem) {
                    return [gifts[0],gifts[1],gifts[2],gifts[3],critical,finalItem]
                } else if(nextItem && (nextItem.referrals <= gifts[3].referrals)) {
                    return [gifts[0],gifts[1],gifts[2],gifts[3],critical,finalItem]
                } else {
                    return [gifts[0],gifts[1],gifts[nextIndex-1],nextItem,critical,finalItem]
                }
            }
        })

        const referralsArray = computed(() => {
            // new updates
            let arr1 = filteredGifts.value
            let arr = [] as any;
            if(arr1 === null) {
                return []
            } else {
                for(let i=0 ; i<arr1.length ; i++) {
                if(arr1[i] && arr1[i].referrals) {
                     arr.push(arr1[i].referrals as any)
                }
            }
            return arr.sort((a,b)=>(a-b))
            }
        })

        const getAgentType = computed(()=> {
            if(isAndroid()) return 1;
            else if(isIOS()) return 2;
            else return 0
        })

        const errorRoute = computed(() =>
            ({
                path: '/error',
                query: { lang: route.query.lang??'cn',title: local.value.share_error }
            })
        )

        const getLabelStyleMode = computed(() => {
            let widthLabel = labelWidth.value 
            if(widthLabel <= 65) return 'left'
            else if(widthLabel >65 && widthLabel <= 86 ) return 'middle'
            else return 'reverse-left'
        })

        const langQuery = computed(() =>
            route.query.lang?.toString().toLowerCase() ?? 'cn'
        )

        const state = reactive({
            isCopiedLink: false,
            isCopiedCode: false,
            isReferralRewards: false,
            showLoading: false,
            isDialogShareCode: false,
            isDialogRewardsRecords: false,
            isApplyGiftDialog: false,
            isSuccessDialog: false,
            isRewardRulesDialog: false
        })
        const data = reactive({
            selectedGift: null,
            encryptedToken: decodeURIComponent(route.query.id as any ?? ' ').replace(/\s/g, '+').replace(/%2B/g, '+'),
            defaultShareInfo: {
                        status: null,
                        message: '',
                        inviteCode: '******',
                        invitesShareCount: 0,
                        // InvitesActiveUserShareCount:0,
                        availableSharePoints: 0,
                        userTotalInSharePoints:0,
                        availablePurchasePoints: 0,
                        pendingPurchasePoints: 0,
                        availablePurchasePointsYuan: 0,
                        redeemedTrafficPackages: [],
                        yesterdayPoints: 0,
                        withdrawnPoints: 0,
                        isSuccess: false,
                        share_rebate: [{ new_purchase_percent: 0, renew_percent: 0 }, { new_purchase_percent: 0, renew_percent: 0 }, { new_purchase_percent: 0, renew_percent: 0 }],
                        user_name: '',
                        withdrawnYuan: 0,
                        userAvailablePurchasePointsNoRefundNoPending: 0,
                        userAvailablePurchasePointsNoRefundNoPendingYuan: 0,
                        MaxReferralsOfAvailableGifts: 0,
                        extraGiftedPoints: 0,
                        sharesThisMonth: {
                            total_inactive_invites: 0,
                            total_invites: 0,
                            total_active_invites: 0
                        },
                        sharesLastSixMonths: {
                            total_inactive_invites: 0,
                            total_invites: 0,
                            total_active_invites: 0
                        },
                        currentMonthSharePointsIn:0,
                        currentMonthPurchasePointsIn:0,
                        sixMonthsSharePointsIn:0,
                        sixMonthsPurchasePointsIn:0,
                        // share_gifted_points: 0
                    },
                    monthNames: [
                        { en: 'January', zh: '1' },
                        { en: 'February', zh: '2' },
                        { en: 'March', zh: '3' },
                        { en: 'April', zh: '4' },
                        { en: 'May', zh: '5' },
                        { en: 'June', zh: '6' },
                        { en: 'July', zh: '7' },
                        { en: 'August', zh: '8' },
                        { en: 'September', zh: '9' },
                        { en: 'October', zh: '10' },
                        { en: 'November', zh: '11' },
                        { en: 'December', zh: '12' }
                    ]
        })

        function back() {
            router.back()
        }

        async function applyGifts(gift) {
            data.selectedGift = gift
            openComponent('isApplyGiftDialog')
        }

        async function submitGift(type,id) {
            closeComponent('isApplyGiftDialog')
            openComponent('showLoading')
            if(data.selectedGift) {
                const body = {
                "gift_id": id,
                "type":type==='points'?'points':'pk',
                "lang": langQuery.value
            }

            let res = await callPostApi('/user/points/gifts/apply', 'POST', JSON.stringify(body),data.encryptedToken as any)
            .catch(() => {
                router.push(errorRoute.value)
            })
            
            closeComponent('showLoading')
            if(res.isSuccess && res.status) {
                openComponent('isSuccessDialog')
                // send message to the android app.
                sendMessageToFlutter('refreshUserPlans')
                // update gifts
                await store.dispatch('share/updateStateGift', id)

                // update points.
                let resData = await callApi(`/user/points`, 'GET', data.encryptedToken as any)
                if (resData.isSuccess) {
                    await store.dispatch('share/setShareInfo', resData)
                } else {
                    await store.dispatch('share/setShareInfo', data.defaultShareInfo)

                    router.push(errorRoute.value)
                }


            } else {
                showErrorTips(local.value.claim_faild)
            }

            }
        }

        function updateLabelWidth() {
            labelWidth.value = leftLabelRef.value?.clientWidth ?? 0
        }

        function changeTab(tab) {
            currentTab.value = tab;
        }

        function createQRCode(link: string) {
            const qrcode = new QRCode('qrcode', {
                width: 142,
                height: 142,
            })
            const updatedLink = link.includes('?') ? `${link}&p=url&lang=${route.query.lang ?? 'cn'}` : `${link}?p=url&lang=${route.query.lang ?? 'cn'}`
            qrcode.makeCode(updatedLink)
        }

        function copyCode(value) {
            const success = copyToClipboardUsingTextarea(value)// Call the utility function
            state.isCopiedCode = true
            copiedCode()
            console.log(success)
        }

        function copyLink() {
            const updatedLink = link.value.includes('?') ? `${link.value}&p=url&lang=${route.query.lang ?? 'cn'}` : `${link.value}?p=url&lang=${route.query.lang ?? 'cn'}`
            const success = copyToClipboardUsingTextarea(updatedLink)
            toggleComponent('isCopiedLink')
            console.log(success)
        }

        function copiedCode() {
            if (state.isCopiedCode && tipsRef.value) {
                tipsRef.value.showTips({
                    show: true,
                    title: local.value.share_25
                })
                return false
            }
        }

        function closeTab_() {
            console.log('close')
            sendMessageToFlutter('clickBack')
        }

        function takeScreenisDone() {
            if (tipsRef.value) {
                tipsRef.value.showTips({
                    show: true,
                    title: local.value.share_26
                })
                return false
            }
        }

        function toggleComponent(name: string) {
            if (name in state) {
                    state[name] = !state[name]
            }
        }

        const captureScreenshot = async () => {
            if (screenShotRef.value) {
                screenShotRef.value.captureScreenshot(shareInfo.value.inviteCode) // Call the method in child
            }
        };

        const closeComponent = (name: string) => {
            if (name in state) {
                state[name] = false
            }
        }

        const openComponent = (name: string) => {
            if (name in state) {
                state[name] = true
            }
        }

        const getFormatedMonthsReward = (lang) => {
            if(lang == 'cn') {
                return `${currentMonth.value.number}月1日 - ${currentMonth.value.number}月${lastDayFromMonth.value}日`
            }  else {
                return `${currentMonth.value.name} 1st - ${currentMonth.value.name} ${lastDayFromMonth.value}st` 
            }
        }

        const closeSaveImageDialog = async () => {
            await store.dispatch('share/setSaveImage',0)
        }

        const showErrorTips = (msg) => {
            if (msg && errorRef.value) {
                errorRef.value.showTips({
                    show: true,
                    title: msg
                })
                return false
            }
        }

        return {
            host,
            back,
            createQRCode,
            copyCode,
            tipsRef,
            textToCopy,
            copyLink,
            state,
            toggleComponent,
            local,
            data,
            captureScreenshot,
            screenShotRef,
            shareInfo,
            closeComponent,
            openComponent,
            takeScreenisDone,
            currentMonth,
            lastDayFromMonth,
            getFormatedMonthsReward,
            nextStep,
            getCurrentWidth,
            giftsList,
            closeTab_,
            changeTab,
            currentTab,
            applyGifts,
            submitGift,
            currentLabel,
            currentPointsBalance,
            currentDataTab,
            referralsArray,
            filteredGifts,
            saveImage,
            closeSaveImageDialog,
            errorRef,
            getAgentType,
            currentPointsMode,
            leftLabelRef,
            getLabelStyleMode,
            langQuery
        }
    }
}
